window.app = new Vue({
    el: '#oferta',
    data: function(){
        // if(window.location.hostname === 'verointernet.com.br' || location.hostname === 'veronovo.visie.link') {
        //     var router = 'https://' + window.location.hostname + '/api';
        // } else if (window.location.hostname === 'vero2021.h.visie.link') {
        //     var router = 'http://' + window.location.hostname + ':3042';
        // } else {
        //     var router = 'http://' + window.location.hostname + ':3002';
        // }


        if(window.location.hostname === 'verointernet.com.br' || window.location.hostname == 'veronovo.visie.link' || window.location.hostname == 'newvero.visie.link') {
            var router = 'https://' + window.location.hostname + '/api';
        } else if (window.location.hostname === 'vero.betas.visie.link'){
            var router = 'https://' + window.location.hostname + ':3142';
        } else if (window.location.hostname === 'vero2021.h.visie.link') {
            var router = 'http://' + window.location.hostname + ':3042';
        } else {
            var router = 'http://' + window.location.hostname + ':3002';
        }
        return{
            idOferta = null,
            plano_atual: null,
            plano_ofertado: null,
            valor_real_plano_ofertado = null,
            cliente: null,
            erro: null,
            success: false,
            check_fatura: true,
            default_route: (location.hostname === 'verointernet.com.br' || location.hostname === 'veronovo.visie.link') ? 'https://' + location.hostname :  'http://' + location.hostname,
            default_route_api: router,
        }
    },
    methods: {

        atualizarValorOfertado(event){
            var checked = document.getElementById("check_oferta").checked;
            var valor = null;
            if(!checked){
                this.check_fatura = false;
                valor = this.dividirValor(this.valor_real_plano_ofertado);
                this.plano_ofertado["valor"] = valor["principal"];
                this.plano_ofertado["decimos"] = valor["decimos"];
            }else{
                this.check_fatura = true;
                valor = this.dividirValor(this.valor_real_plano_ofertado - this.plano_ofertado.valorDescontoFatura);
                this.plano_ofertado["valor"] = valor["principal"];
                this.plano_ofertado["decimos"] = valor["decimos"];
            }
        },

        dividirValor(valor){
            var retorno = {};
            var trim = valor.toString().split(".");

            retorno["principal"] = trim[0];
            retorno["decimos"] = trim[1] ? trim[1] : "00";

            return retorno;
        },


        confirmar(){
            var id = this.idOferta;

            document.getElementById("btn-send").disabled = false;
            document.getElementById("icon-load").style.display = "none";
            
            var requestOptions = {
                method: 'POST',
            };

            fetch(`${this.default_route_api}/update-oferta/${id}`, requestOptions)
            .then(response => response.json())
            .then(result =>{ 
                console.log("Enviando upgrade")
                console.log(result);
                this.sendUpgrade();
            })
            .catch(error => {
                console.log("Erro no put")
                document.getElementById("warning").style.display = "block";
                document.getElementById("btn-send").disabled = false;
                document.getElementById("icon-load").style.display = "none";
            }
            );

            
        },

        sendUpgrade(){
    
            document.getElementById("btn-send").disabled = true;
            document.getElementById("icon-load").style.display = "inline-block";

            var formdata = new FormData();
            formdata.append("nome", this.cliente.nome);
            formdata.append("email", this.cliente.email);
            formdata.append("cpfcnpj", this.cliente.documento);
            formdata.append("telefone", this.cliente.telefone);
            formdata.append("cidade", this.cliente.cidade);
            formdata.append("bairro", this.cliente.bairro);
            formdata.append("plano__atual", this.plano_atual.nome + " - R$ " + this.plano_atual.valor);
            formdata.append("plano__novo", this.plano_ofertado.velocidade + " - R$ " + this.plano_ofertado.valor);
            formdata.append("plano__url", "oferta");
            formdata.append("origem",  this.cliente.origem);
            formdata.append("fatura_digital", this.check_fatura);

            var requestOptions = {
            method: 'POST',
            body: formdata,
            };

            fetch(`${this.default_route}/sendupgrade.php`, requestOptions)
            .then(response => response.json())
            .then(result =>{ 
                document.getElementById("modal-success").style.display = "flex";
                this.redirect();
            })
            .catch(error => {
                document.getElementById("warning").style.display = "block";
                document.getElementById("btn-send").disabled = false;
                document.getElementById("icon-load").style.display = "none";
            }
            );
        },

        redirect(){
            setTimeout(function(){
                window.location.href = window.location.origin
            }, 10000);
        }

    },
    computed: {
        
    },
    watch: {

    },
    created(){
        // Pegando o id da oferta
        var url_string = window.location.href;
        var url = new URL(url_string);
        var id = url.searchParams.get("id_oferta");
        var api = this.default_route_api + "/ofertas/"+id;

        this.idOferta = id;

        console.log("obtendo oferta por id")

        fetch(api)
            .then(response => response.json())
            .then(response => {
                if(response.message){

                    this.plano_atual = null;
                    this.plano_ofertado = null;
                    this.cliente = null;
                    this.erro = "Id da oferta inválido";
                }else{
                var atual = {};
                var ofertado = {};
                var cliente = {};
                
                var speedPlan = response.produtosHistorico[0].velocidadePlanoMb;
                var speedPlanOffer = response.produtosDisponiveis[0].velocidadePlanoMb;

                atual["velocidade"] = speedPlan;
                atual["idPlano"] = response.produtosHistorico[0].idPlano;
                atual["nome"] = response.produtosHistorico[0].nomePlano;
                atual["valor"] = response.produtosHistorico[0].valorPlano.toString().split(".")[0];
                atual["decimos"] = response.produtosHistorico[0].valorPlano.toString().split(".")[1] ? response.produtosHistorico[0].valorPlano.toString().split(".")[1] : "00";
                atual["beneficios"] = response.produtosHistorico[0].beneficios.length > 0 ? response.produtosHistorico[0].beneficios : null;
                
                // Variável que recebe valor com desconto caso a fatura digital esteja habilitada
                var valorPlanoFaturaChecked = this.check_fatura && response.produtosDisponiveis[0].descontoFaturaDigital != null ? response.produtosDisponiveis[0].valorPlano - response.produtosDisponiveis[0].descontoFaturaDigital : response.produtosDisponiveis[0].valorPlan;
                var valorPlanoFormatado = this.dividirValor(valorPlanoFaturaChecked);

                this.valor_real_plano_ofertado = response.produtosDisponiveis[0].valorPlano;

                ofertado["velocidade"] = speedPlanOffer;

                ofertado["idPlano"] = response.produtosDisponiveis[0].idPlano;
                ofertado["nome"] = response.produtosDisponiveis[0].nomePlano;
                ofertado["valor"] = valorPlanoFormatado["principal"];
                ofertado["decimos"] = valorPlanoFormatado["decimos"];
                ofertado["beneficios"] = response.produtosDisponiveis[0].beneficios.length > 0 ? response.produtosDisponiveis[0].beneficios : null;
                ofertado["valorDescontoFatura"] = response.produtosDisponiveis[0].descontoFaturaDigital ? (response.produtosDisponiveis[0].descontoFaturaDigital.toFixed(2)) : 0;
                
                cliente["nome"] = response.cliente.nome == "" ? "nome vazio (Oferta)" : response.cliente.nome;
                cliente["cidade"] = response.cliente.cidade == "" ? "Cidade vazia (Oferta)" : response.cliente.cidade;
                cliente["bairro"] = response.cliente.bairro == ""? "Bairro vazio (Oferta)": response.cliente.bairro;
                cliente["email"] = response.cliente.email == ""? "vazio@oferta.com" : response.cliente.email;
                cliente["documento"] = response.cliente.numeroDocumento == "" ? "Documento vazio (Oferta)" : response.cliente.numeroDocumento;
                cliente["telefone"] = response.cliente.numeroTelefone == ""? "Telefone vazio (Oferta)" : response.cliente.numeroTelefone;
                cliente["origem"] = "SITE-OFERTA";

                this.plano_atual = atual;
                this.plano_ofertado = ofertado;
                this.cliente = cliente;
                this.success = false;
                }
            })
        .catch(err => {
            console.log(err);
            this.plano_atual = null;
            this.plano_ofertado = null;
            this.cliente = null;
            this.erro = "Ocorreu algum erro, tente mais tarde.";
        });
        document.getElementById("oferta").style.display = "block";
        
    },

})
